<div class="ui-modal-item-summary">
  @for (field of fields(); track field.label) {
    <article class="ui-modal-item-summary__item">
      <span class="ui-modal-item-summary__label">
        {{ field.label }}
      </span>

      <span
        class="ui-modal-item-summary__value"
        [class.ui-modal-item-summary__value--danger]="field.tone === 'danger'"
        [class.ui-modal-item-summary__value--success]="field.tone === 'success'"
        [class.ui-modal-item-summary__value--muted]="field.tone === 'muted'"
      >
        {{ field.value }}
      </span>
    </article>
  }
</div>